<template>
    <v-dialog ref="dialog" persistent max-width="400">
        <v-card class="dialog-confirm">
            <v-card-title class="pa-5">{{ title }}</v-card-title>
            <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn depressed color="error" @click.prevent="cancel" min-width="100" class="mx-2">{{ cancelBtn }}</v-btn>
                <v-btn depressed color="success" @click.prevent="confirm" min-width="100">{{ confirmBtn }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name   : "Confirm",
        props  : {
            title     : {
                type   : String,
                default: '',
            },
            cancelBtn : {
                type   : String,
                default: 'Нет',
            },
            confirmBtn: {
                type   : String,
                default: 'Да',
            }
        },
        methods: {
            cancel() {
                this.$emit('resolve', false);
            },
            confirm() {
                this.$emit('resolve', true);
            }
        }
    }
</script>

<style lang="scss">
    
    .dialog-confirm {
        
        
        .v-card__title {
            font-size: 20px;
            line-height: 26px;
        }
        
    
        .v-card__actions {
            background-color: #f1f1f1;
        }
    }
</style>
